export const LOCALE_STORAGE_KEY = 'rapoo-locale'

// 这里如果改值了要去releaseNotes改对应的文件夹名称
export const ZH_CN_LOCALE = 'zh-CN'
export const EN_US_LOCALE = 'en-US'
export const DEFAULT_LOCALE = ZH_CN_LOCALE

const LOCALE_MAP = {
  zh: ZH_CN_LOCALE,
  [ZH_CN_LOCALE]: ZH_CN_LOCALE,
  en: EN_US_LOCALE,
  [EN_US_LOCALE]: EN_US_LOCALE,
} as const

export type AppLocale = (typeof LOCALE_MAP)[keyof typeof LOCALE_MAP]

export function normalizeLocale(locale?: string | null): AppLocale {
  if (!locale) return DEFAULT_LOCALE

  return LOCALE_MAP[locale as keyof typeof LOCALE_MAP] ?? DEFAULT_LOCALE
}
